import { render, staticRenderFns } from "./ProductKategoriView.vue?vue&type=template&id=1c06ff85&"
import script from "./ProductKategoriView.vue?vue&type=script&lang=js&"
export * from "./ProductKategoriView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports